import React from "react";

export default function SQLServer_DATEDIFF() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_DATEDIFF</h1>
      <p>This is the SQLServer_DATEDIFF component generated from the SQL JSON.</p>
    </div>
  );
}
